import {GetterConfigArgs, IConfigurable, Transerializable, numberOr} from '@eventops/athlinks-get-or'
import {ITime, Time} from '../common/time'
import {IPace, Pace} from '../common/pace'
import {Distance, IDistance} from '../common/distance'
import {RaceType, IntervalRaceType} from '../common/raceType'

// holder for the results
export interface IEventInterval {
  distance: IDistance,
  intervalFull: boolean,
  intervalId: number,
  intervalName: string,
  intervalOrder: number,
  intervalRaceType: IntervalRaceType,
  intervalType: string,
  intervalResults: IEventIntervalResult[],
  isLeg: boolean,
}

export class EventInterval extends Transerializable implements IEventInterval {
  public distance = new Distance()
  public intervalType = ''
  public intervalRaceType = IntervalRaceType.UNDEFINED
  public intervalResults: IEventIntervalResult[] = []
  public isLeg = false
  public intervalFull = false
  public intervalId = 0
  public intervalName = ''
  public intervalOrder = 0
}

// represents a single result for an erp.
export interface IEventIntervalResult {
  age: number,
  entryId: number, // The EntryId in the vr_t_Entry table in athlinks
  bib: string,
  country: string,
  thirdPartyEntryId: number, // CtLiveEntryId
  displayName: string,
  entryStatus: string, // CONF, etc. Represents confirmed, withdrawn, disqualified, etc.
  entryType: string, // IND, etc
  firstName: string,
  gender: string,
  genderRank: number,
  intervalName: string,
  intervalOrder: number,
  intervalRaceType: IntervalRaceType,
  lastName: string,
  locality: string,
  overallRank: number,
  pace: IPace,
  postalCode: string,
  primaryBracketRank: number,
  racerId: number,
  region: string,
  regionId: string,
  time: ITime
}

export class EventIntervalResult extends Transerializable implements IEventIntervalResult, IConfigurable {
  public age = 0
  public entryId = 0
  public bib = ''
  public country = ''
  public thirdPartyEntryId = 0
  public displayName = ''
  public entryStatus = ''
  public entryType = ''
  public firstName = ''
  public gender = ''
  public genderRank = 0
  public intervalName = ''
  public intervalOrder = 0
  public intervalRaceType: IntervalRaceType.UNDEFINED
  public lastName = ''
  public locality = ''
  public overallRank = 0
  public pace = new Pace()
  public postalCode = ''
  public primaryBracketRank = 0
  public racerId = 0
  public region = ''
  public regionId = ''
  public time = new Time()

  public config: GetterConfigArgs = {
    optionalPartialConfig: {
      timeInMilliseconds: {
        dotPaths: 'ticks',
        getter: numberOr
      }
    }
  }
}

// final object to hold and erp and leaderboard result.
export interface IEventResult {
  courseId: number, // courseId from vr_t_Course in Athlinks
  eventCourseId: number,
  eventCourseName: string,
  eventId: number,
  bracketId: number,
  bracketName: string,  // Overall, Male, M 20-25, etc
  bracketRankType: string, // CHIP, GUN, etc
  bracketTag: string, // ALL, etc
  bracketType: string, // OVERALL, GENDER, AGE, etc
  interval: IEventInterval,
  thirdParySystemRaceId: number, // RaceId from ThirdParty (CTLive)
  raceType: RaceType, // running, triathalon etc
  totalAthletes: number,
  hasPace: boolean // only true for single leg events (Running, etc)
}

export class EventResult extends Transerializable implements IEventResult {
  public courseId = 0
  public eventCourseId = 0
  public eventCourseName = ''
  public eventId = 0
  public bracketId = 0
  public bracketName = ''
  public bracketRankType = ''
  public bracketTag = ''
  public bracketType = ''
  public interval = new EventInterval()
  public thirdParySystemRaceId = 0
  public raceType = RaceType.UNDEFINED
  public totalAthletes = 0
  public totalInBracket = 0
  public hasPace = false
}
